export const CONTACT = {
  phonePrimary: "+91 90529 10159",
  phonePrimaryRaw: "+919052910159",
  phoneSecondary: "+91 99850 11152",
  email: "hello@megacelebrityevents.com",
  address: "Sri Akshita Oaks, Currency Nagar, Vijayawada, Andhra Pradesh – 520008",
  whatsapp:
    "https://wa.me/919052910159?text=Hello%20Mega%20Celebrity%20Events%2C%20I%20would%20like%20to%20plan%20an%20event.%20Event%20Type%3A%20%20Event%20Date%3A%20%20City%3A%20%20Expected%20Guests%3A",
  directions:
    "https://www.google.com/maps/search/?api=1&query=Sri+Akshita+Oaks%2C+Currency+Nagar%2C+Vijayawada%2C+Andhra+Pradesh+520008",
};

const U = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85`;

export const IMG = {
  hero: U("photo-1492684223066-81342ee5ff30"),
  concert: U("photo-1459749411175-04bf5292ceea"),
  crowd: U("photo-1470229722913-7c0e2dbbafd3"),
  stagePurple: U("photo-1514525253161-7a46d19cd819"),
  production: U("photo-1505373877841-8d25f7d46678"),
  wedding: U("photo-1519167758481-83f550bb49b3"),
  banquet: U("photo-1511795409834-ef04bbd61622"),
  corporate: U("photo-1540575467063-178a50c2df87"),
  audience: U("photo-1475721027785-f74eccf877e2"),
  cinema: U("photo-1489599849927-2ee91cede3ba"),
  dining: U("photo-1414235077428-338989a2e8c0"),
  party: U("photo-1517457373958-b7bdd4587205"),
  dinnerEvent: U("photo-1464366400600-7168b8af9bc3"),
  dimStage: U("photo-1429962714451-bb934ecdc4ec"),
  backstage: U("photo-1470225620780-dba8ba36b745"),
};

export const EXPERIENCES = [
  {
    slug: "celebrity-appearances",
    title: "Celebrity Appearances",
    tagline: "The right presence changes the room.",
    image: IMG.dinnerEvent,
    description:
      "High-impact celebrity participation for launches, celebrations, public appearances and promotional events — coordinated professionally and confidentially, from first conversation to final wave.",
    includes: ["Talent shortlisting & coordination", "Appearance flow & scheduling", "Hospitality & protocol", "Media moment planning"],
  },
  {
    slug: "concerts-live-shows",
    title: "Concerts & Live Shows",
    tagline: "Built for the front row.",
    image: IMG.concert,
    description:
      "Live entertainment experiences shaped through talent, production, audience flow and on-ground coordination — from intimate acoustic evenings to arena-scale spectacles.",
    includes: ["Artist & band coordination", "Stage, sound & lighting", "Audience flow management", "Show-day operations"],
  },
  {
    slug: "luxury-weddings",
    title: "Luxury Weddings",
    tagline: "Grandeur, gracefully delivered.",
    image: IMG.wedding,
    description:
      "Grand celebrations combining entertainment, hospitality, guest experience and premium event execution — a wedding that feels like a premiere.",
    includes: ["Celebrity & artist performances", "Décor & visual styling", "Guest hospitality", "Multi-day event flow"],
  },
  {
    slug: "corporate-events",
    title: "Corporate Events",
    tagline: "Polished. Precise. On brand.",
    image: IMG.corporate,
    description:
      "Professional conferences, award nights, annual events and leadership gatherings with a polished brand experience and five-star discipline.",
    includes: ["Stage & AV production", "Award-night show flow", "Delegate hospitality", "Brand environment design"],
  },
  {
    slug: "brand-showroom-launches",
    title: "Brand & Showroom Launches",
    tagline: "Openings people talk about.",
    image: IMG.hero,
    description:
      "Attention-generating openings, product reveals, mall activations and promotional appearances — designed to be seen, created to be remembered.",
    includes: ["Celebrity inauguration", "Reveal & entry concepts", "Media visibility", "Crowd & access control"],
  },
  {
    slug: "private-vip-celebrations",
    title: "Private VIP Celebrations",
    tagline: "Discreet. Distinctive. Yours.",
    image: IMG.banquet,
    description:
      "Discreet, carefully curated experiences for important personal and family occasions — every detail considered, every guest made to feel expected.",
    includes: ["Private entertainment", "Curated dining & décor", "Confidential coordination", "Personal concierge"],
  },
  {
    slug: "political-public-events",
    title: "Political & Public Events",
    tagline: "Order at scale.",
    image: IMG.audience,
    description:
      "Structured support for public programmes, meetings, rallies and high-footfall gatherings — planned with discipline and delivered with calm.",
    includes: ["Stage & public address", "Crowd-flow coordination", "VIP movement support", "Media & press areas"],
  },
  {
    slug: "film-media-promotions",
    title: "Film & Media Promotions",
    tagline: "Give the story a stage.",
    image: IMG.cinema,
    description:
      "Premieres, promotional events, press interactions and audience-facing media experiences for film and entertainment brands.",
    includes: ["Premiere production", "Press & fan interactions", "Cast movement & protocol", "Promotional appearances"],
  },
];

export const TALENT_CATEGORIES = [
  "Film Personalities",
  "Singers & Music Artists",
  "DJs",
  "Anchors & Hosts",
  "Television Personalities",
  "Influencers",
  "Sports Personalities",
  "Stand-up Performers",
  "Regional Artists",
  "Comedians & Performers",
];

export const PILLARS = [
  { num: "01", title: "Creative Impact", text: "Concepts designed around the audience, occasion and desired public impression." },
  { num: "02", title: "Celebrity Experience", text: "Professional coordination of talent, hospitality, schedules and event movement." },
  { num: "03", title: "Production Control", text: "Structured alignment of stage, sound, light, visuals, vendors and timelines." },
  { num: "04", title: "Guest Hospitality", text: "Thoughtful arrival, reception, protocol and guest-flow support." },
  { num: "05", title: "On-Ground Execution", text: "A clearly coordinated team working from setup through event closure." },
];

export const PROCESS = [
  { num: "01", title: "Discover", text: "Understand the occasion, audience, location, vision and priorities." },
  { num: "02", title: "Conceptualise", text: "Shape the event theme, experience, talent direction and production requirements." },
  { num: "03", title: "Curate", text: "Identify suitable entertainment, vendors, hospitality elements and guest experiences." },
  { num: "04", title: "Produce", text: "Coordinate stage, sound, lighting, visuals, technical teams and rehearsal requirements." },
  { num: "05", title: "Execute", text: "Manage event-day timelines, talent movement, hospitality and on-ground coordination." },
  { num: "06", title: "Complete", text: "Coordinate event closure, vendor movement and agreed post-event requirements." },
];

export const LOCATIONS = [
  { slug: "vijayawada", name: "Vijayawada", note: "Our home base — full production, talent and hospitality teams on ground." },
  { slug: "guntur", name: "Guntur", note: "Concerts, weddings and public programmes across the Guntur region." },
  { slug: "amaravati", name: "Amaravati", note: "Government, corporate and public gathering support in the capital region." },
  { slug: "hyderabad", name: "Hyderabad", note: "Arena concerts, film promotions and luxury celebrations across the city." },
  { slug: "visakhapatnam", name: "Visakhapatnam", note: "Coastal launches, destination weddings and large-format live shows." },
  { slug: "tirupati", name: "Tirupati", note: "Devotional programmes, VIP celebrations and high-footfall gatherings." },
];

export const PRODUCTION_ITEMS = [
  "Creative event concept",
  "Stage design",
  "Professional sound",
  "Intelligent lighting",
  "LED walls & displays",
  "Artist technical riders",
  "Special effects",
  "Décor coordination",
  "Entry & reveal concepts",
  "Technical rehearsals",
  "Photography & cinematography",
  "Live-event operations",
];

export const HOSPITALITY_ITEMS = [
  "Celebrity hospitality",
  "VIP reception",
  "Airport & hotel coordination",
  "Venue arrival support",
  "Green-room coordination",
  "Artist hospitality",
  "Guest assistance",
  "Protocol support",
  "Family & organiser coordination",
  "Transport scheduling",
];

export const SECURITY_ITEMS = [
  "Premium event bouncers",
  "Celebrity & VIP movement",
  "Entry & exit management",
  "Crowd-flow coordination",
  "Backstage control",
  "Restricted-area access",
  "Parking & vehicle flow",
  "Guest-conscious security presence",
];

export const MARQUEE_ITEMS = [
  "Celebrity Appearances",
  "Luxury Weddings",
  "Concerts & Live Shows",
  "Brand Launches",
  "Corporate Galas",
  "VIP Celebrations",
  "Film Promotions",
  "Public Programmes",
];
